import { NotFound } from './dumb.js';

export default NotFound;
